<template>
	<div class="track">
		<h4>
			{{ props.title }}
		</h4>
		<template v-for="s in props.src">
			<audio controls :src="s" @play="play"></audio>
			<br />
		</template>
		<div class="desc">
			<slot></slot>
		</div>
	</div>
</template>
<script setup>
import { ref } from 'vue';


const props = defineProps(["title", "src"]);
const previous = ref()
function pause(except) {
	// console.log("attempting to pause");
	Array.from(document.getElementsByTagName("audio"))
		.forEach((e) => e.pause());
	except.play()
}
function play(event) {
	console.log(event.target)
	if (previous.value && event.target !== previous.value) {
		previous.value.pause()
		previous.value.fastSeek(0)
	}
	previous.value = event.target;
}
</script>
